import { render, staticRenderFns } from "./ActiveFilterItem.vue?vue&type=template&id=1e99f47a&scoped=true"
import script from "./ActiveFilterItem.vue?vue&type=script&lang=js"
export * from "./ActiveFilterItem.vue?vue&type=script&lang=js"
import style0 from "./ActiveFilterItem.vue?vue&type=style&index=0&id=1e99f47a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e99f47a",
  null
  
)

export default component.exports